import { useRequest } from 'ahooks';
import {
  apiV2EnvMonitorDashboardOverallTrendPost,
  V2EnvMonitorDashboardOverallTrendPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import dayjs from 'dayjs';
import { TrendGranularity } from '../types';
import { formatRequestTime } from '../utils';
import { DEVICE_TYPE_MAP } from '../constants';

export type TrendDataPoint = Exclude<V2EnvMonitorDashboardOverallTrendPostResponse['chartData'], undefined>[number];
export type OverallTrendData = V2EnvMonitorDashboardOverallTrendPostResponse;

const GRANULARITY_MAP: Record<TrendGranularity, string> = {
  [TrendGranularity.HOUR]: 'H',
  [TrendGranularity.DAY]: 'D',
  [TrendGranularity.MONTH]: 'M',
};

export const useOverallTrend = (
  deviceType: DEVICE_TYPE_MAP,
  propertyId: number,
  granularity: TrendGranularity,
  dateRange: [dayjs.Dayjs, dayjs.Dayjs] | null,
  refreshKey: number
) => {
  const gran = GRANULARITY_MAP[granularity];

  return useRequest(
    async () => {
      if (!propertyId || !dateRange?.[0] || !dateRange?.[1]) return undefined;
      const { startTime, endTime } = formatRequestTime(dateRange, granularity);
      return await apiV2EnvMonitorDashboardOverallTrendPost({
        deviceType,
        propertyId,
        granularity: gran,
        startTime,
        endTime,
      });
    },
    {
      ready: !!propertyId && !!dateRange?.[0] && !!dateRange?.[1],
      refreshDeps: [deviceType, propertyId, granularity, dateRange, refreshKey],
    }
  );
};
